import React, { useState,useEffect } from "react";
import "./TVService.css";
import DisplayIssueRepair from "../images/tv hero.webp";
import  TVMaintenance from "../images/TVMaintenance.webp";
import  TVInstallation from "../images/TV Installation.webp";
import SoundIssueRepair from "../images/SoundIssueRepair.webp";
import  SmartTVRepair from "../images/Smart TV Repair.webp";
import Doorsteptv from "../images/Doorstep tv.webp";
import customer1 from "../images/cutomer1.webp";
import TelevisionRepairSupport from "../images/tv hero.webp";


function TVService() {
      useEffect(() => {
    
        document.title =
          "TV Service - Embarque Services";
    
      }, []);
  
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      location: "",
      issue: "",
    });
  
    const [loading, setLoading] = useState(false);
  
    const handleChange = (e) => {
  
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
  
    };
  
    const handleSubmit = async (e) => {
  
      e.preventDefault();
  
      setLoading(true);
  
      const sendData = {
        ...formData,
        toMail: "expresshelplinecare@gmail.com",
      };
  
      try {
  
        const res = await fetch(
          "https://form.e2ecrm.in/api/sendmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData),
          }
        );
  
        await res.json();
  
        alert(
          "Thank you! Your service request is confirmed. Our engineer will call you shortly."
        );
  
        setFormData({
          name: "",
          phone: "",
          location: "",
          issue: "",
        });
  
      } catch (err) {
  
        console.log(err);
  
        alert("Error sending form");
  
      } finally {
  
        setLoading(false);
  
      }
    };
  
  return (
   <>
   
      {/* SPINNER */}

      {loading && (

        <div className="spinner-overlay">

          <div className="spinner"></div>

        </div>

      )}

      {/* TV HERO SECTION */}

      <div className="tv-home">

        <section className="tv-hero">

          {/* LEFT APPLIANCE */}

          <div className="tv-appliance-section">

            {/* <img
              className="tv-machine-img"
              src="https://cdn-icons-png.flaticon.com/512/1041/1041916.png"
              alt="TV Service"
            /> */}

          </div>

          {/* CONTENT */}

          <div className="tv-content">

            <h1>
              Television <br />
              Repair & <br />
              Maintenance <br />
              Service At <br />
              Your Doorsteps
            </h1>

          </div>

          {/* FORM */}

          <div className="tv-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your television service complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the TV issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>

              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

        </section>

      </div>

{/* TV ABOUT SECTION */}

<section className="tv-about-section">

  <div className="tv-about-left">

    <h1>
      Trusted TV <br />
      Repair Experts <br />
      for Your <br />
      Entertainment <br />
      Needs
    </h1>

    <div className="tv-about-box">

      <p>
        With 8+ years of experience in television repair,
        our technicians provide fast and reliable doorstep support.
      </p>

      <p>
        From display issues to motherboard and sound problems,
        we repair all major LED and Smart TV brands professionally.
      </p>

    </div>

  </div>

  <div className="tv-about-right">

    <h4>
      OUR SERVICE ACHIEVEMENTS
    </h4>

    <div className="tv-counter-grid">

      <div className="tv-counter-box">
        <h1>8+</h1>
        <p>Years Experience</p>
      </div>

      <div className="tv-counter-box">
        <h1>35000+</h1>
        <p>TV Repairs</p>
      </div>

      <div className="tv-counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="tv-counter-box">
        <h1>20+</h1>
        <p>Multiple Service Areas Covered</p>
      </div>

    </div>

  </div>

</section>


{/* TV SERVICES SECTION */}

<section className="tv-services-section">

  <h1 className="tv-service-title">
    Our TV Repair Services
  </h1>

  <div className="tv-services-grid">

    {/* CARD 1 */}

    <div className="tv-service-card">

      <img
        src={DisplayIssueRepair}        alt="display issue"
      />

      <h2>
        Display Issue Repair
      </h2>

      <p>
        Professional repair solutions for TVs
        with display lines, no picture, and screen issues.
      </p>

    </div>

    {/* CARD 2 */}

    <div className="tv-service-card">

      <img
        src={TVMaintenance}alt="tv maintenance"
      />

      <h2>
        TV Maintenance
      </h2>

      <p>
        Regular servicing and maintenance support
        to improve television performance.
      </p>

    </div>

    {/* CARD 3 */}

    <div className="tv-service-card">

      <img
        src={ TVInstallation}alt="installation"
      />

      <h2>
        TV Installation
      </h2>

      <p>
        Safe LED and Smart TV installation
        and wall mounting support for homes.
      </p>

    </div>

    {/* CARD 4 */}

    <div className="tv-service-card">

      <img
        src={SoundIssueRepair} alt="sound issue"
      />

      <h2>
        Sound Issue Repair
      </h2>

      <p>
        Fast repair support for speaker issues,
        no sound, and motherboard problems.
      </p>

    </div>

    {/* CARD 5 */}

    <div className="tv-service-card">

      <img
        src={ SmartTVRepair} alt="smart tv repair"
      />

      <h2>
        Smart TV Repair
      </h2>

      <p>
        Expert support for Smart TV software,
        connectivity, and panel related issues.
      </p>

    </div>

    {/* CARD 6 */}

    <div className="tv-service-card">

      <img
        src={Doorsteptv}  alt="doorstep tv service"
      />

      <h2>
        Doorstep TV Service
      </h2>

      <p>
        Quick doorstep television repair support
        from experienced technicians.
      </p>

    </div>

  </div>

</section>

{/* TV WHY CHOOSE US */}

<section className="tv-choose-section">

  <div className="tv-choose-overlay">

    <h4>
      WHY CHOOSE OUR TV SERVICE
    </h4>

    <h1>
      Trusted Television <br />
      Repair Solutions
    </h1>

    <div className="tv-choose-grid">

      {/* BOX 1 */}

      <div className="tv-choose-box">

        <div className="tv-choose-icon">
          📺
        </div>

        <h2>
          Expert TV Repair
        </h2>

      </div>

      {/* BOX 2 */}

      <div className="tv-choose-box">

        <div className="tv-choose-icon">
          ⏰
        </div>

        <h2>
          Same Day Service
        </h2>

      </div>

      {/* BOX 3 */}

      <div className="tv-choose-box">

        <div className="tv-choose-icon">
          💰
        </div>

        <h2>
          Affordable Pricing
        </h2>

      </div>

      {/* BOX 4 */}

      <div className="tv-choose-box">

        <div className="tv-choose-icon">
          🚚
        </div>

        <h2>
          Doorstep Support
        </h2>

      </div>

      {/* BOX 5 */}

      <div className="tv-choose-box">

        <div className="tv-choose-icon">
          ⚡
        </div>

        <h2>
          Display Solutions
        </h2>

      </div>

      {/* BOX 6 */}

      <div className="tv-choose-box">

        <div className="tv-choose-icon">
          👨‍🔧
        </div>

        <h2>
          Experienced Technicians
        </h2>

      </div>

    </div>

  </div>

</section>


{/* TV REQUEST INFO */}

<section className="tv-request-section">

  {/* Left Content */}

  <div className="tv-request-left">

    <h1>
      Television <br />
      Repair Support
    </h1>

    <h2>
      Fast & Reliable <br />
      TV Service at <br />
      Your Doorstep
    </h2>

    <p>
      We provide complete television repair and maintenance
      solutions for homes and offices. Our experienced
      technicians handle display issues, sound problems,
      motherboard repair, Smart TV software issues,
      installation, and servicing with professional
      doorstep support at affordable pricing.
    </p>

  </div>

  {/* Right Image */}

  <div className="tv-request-right">

    <img
      src={TelevisionRepairSupport}alt="tv repair service"
    />

  </div>

</section>

{/* TV CUSTOMER SUPPORT */}

{/* <section className="tv-support-section">

 

  <div className="tv-support-image">

    <img
      src={customer1}  alt="tv customer support"
    />

  </div>

 

  <div className="tv-support-content">

    <h1>
      Television Customer Support
    </h1>


    <div className="tv-support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="tv-support-box">
      <span>+</span>
      <p>Same Day Technician Visit</p>
    </div>

    <div className="tv-support-box">
      <span>+</span>
      <p>Professional LED & Smart TV Support</p>
    </div>

    <div className="tv-support-box">
      <span>+</span>
      <p>Experienced TV Repair Technicians</p>
    </div>

    <div className="tv-support-box">
      <span>+</span>
      <p>Affordable Television Service Charges</p>
    </div>

  </div>

</section> */}

{/* TV FAQ SECTION */}

{/* <section className="tv-faq-section">

  <div className="tv-faq-title">

    <h4>
      FAQ
    </h4>

    <h1>
      Television Service Questions
    </h1>

  </div>

  <div className="tv-faq-container">

  

    <div className="tv-faq-box">

      <h2>
        What TV issues do you repair?
      </h2>

      <p>
        We repair display issues, sound problems,
        motherboard faults, power failure,
        and screen related issues.
      </p>

    </div>

    

    <div className="tv-faq-box">

      <h2>
        Do you repair all TV brands?
      </h2>

      <p>
        Yes, we provide repair and maintenance
        support for all major LED and Smart TV brands.
      </p>

    </div>

     
    <div className="tv-faq-box">

      <h2>
        Do you provide doorstep TV service?
      </h2>

      <p>
        Yes, our technicians provide fast doorstep
        television repair and inspection support.
      </p>

    </div>

     

    <div className="tv-faq-box">

      <h2>
        How quickly can I book a TV service?
      </h2>

      <p>
        You can instantly book your television
        service through phone call or WhatsApp support.
      </p>

    </div>

    

    <div className="tv-faq-box">

      <h2>
        Do you provide motherboard repair support?
      </h2>

      <p>
        Yes, we provide professional motherboard
        repair and replacement support for TVs.
      </p>

    </div>
 

    <div className="tv-faq-box">

      <h2>
        Are your TV service charges affordable?
      </h2>

      <p>
        Yes, we provide transparent and affordable
        television repair pricing with quality service.
      </p>

    </div>

  </div>

</section> */}

<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>



<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>
   
   
   </>
  );
}

export default TVService;